import { useTranslation } from "react-i18next";
import { ContactUpdateInquiriesDefaultEndPage } from "./ContactUpdateInquiriesDefaultEndPage";

export const ContactUpdateInquiriesNotYetOpenPage = () => {
	const { t } = useTranslation();

	return (
		<ContactUpdateInquiriesDefaultEndPage
			headline={t("Contact update not yet active")}
			text={t("The contact update is not yet active. You will receive an e-mail from us when it is activated.")}
		/>
	);
};
